import { Component } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { AsyncSubject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { TranslationService } from '@sdbn/common';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { RoutingLogDetails } from '../routing-log-inspector.model';
import { TransportRoutinglogInspectorService } from '../transport-routinglog-inspector.service';

@Component({
    selector: 'app-transport-routinglog-inspector',
    templateUrl: './transport-routinglog-inspector.component.html',
    styleUrls: ['./transport-routinglog-inspector.component.scss'],
    standalone: false
})
export class TransportRoutinglogInspectorComponent extends AbstractWidgetComponent {

  details = new RoutingLogDetails({});

  inputFormGroup = new FormGroup({});

  isLoading = false;

  constructor(
    public translationService: TranslationService,
    private transportRoutinglogInspectorService: TransportRoutinglogInspectorService
  ) {
    super();

    this.inputFormGroup.addControl('transportLogKey', new FormControl(null, [Validators.required]));
    this.inputFormGroup.controls.transportLogKey.valueChanges.pipe(
      debounceTime(300),
      switchMap(
        () => {
          this.isLoading = true;
          return this.loadLogDetails();
        }
      )
    ).subscribe(
      () => this.isLoading = false
    );
  }

  private loadLogDetails() {
    const subject = new AsyncSubject<void>();

    const transportLogKey = this.inputFormGroup.controls.transportLogKey.value;
    if (transportLogKey != null && transportLogKey.length > 0) {

      try {
        this.transportRoutinglogInspectorService.findRoutingLogDetails(transportLogKey).subscribe(
          result => {
            this.details = result;
            subject.next();
            subject.complete();
          },
          error => {
            this.details = new RoutingLogDetails({});
            subject.next();
            subject.complete();
          }
        );
      } catch (exception) {
        console.log(exception);
        this.details = new RoutingLogDetails({});
        subject.next();
        subject.complete();
      }
    } else {
      this.details = new RoutingLogDetails({});
      subject.next();
      subject.complete();
    }

    return subject;
  }

  onContextChange(contextChange: ContextChange) { }

  onSetElementAndContext() { }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
